import { TaskService } from 'src/app/core/service/task.service';
import { Component, OnInit, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { MessengerService, MessageSubject } from 'src/app/core/service/messenger.service';
import { TextProcessor } from 'src/app/core/utility/text.processor';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';

@Component({
  selector: 'app-task-duedate',
  templateUrl: './task-duedate.component.html',
  styleUrls: ['./task-duedate.component.scss']
})
export class TaskDuedateComponent implements OnInit, OnChanges
{
  @Input() public task: any;
  @Input() public dialogOpened: boolean;

  @Output() public save = new EventEmitter();
  @Output() public closing = new EventEmitter();

  public dueDate: Date = null;

  public reasonReschedule = '';

  public shortTaskName: string;

  constructor(private messengerService: MessengerService,
    private taskService: TaskService,
    private messageHandlerService: MessageHandlerService)
  { }

  public ngOnInit(): void
  {
    this.reasonReschedule = '';
  }

  public ngOnChanges(): void
  {
    if (this.task !== null)
    {
      this.dueDate = this.task.dueDate !== null ? new Date(this.task.dueDate) : null;
      this.shortTaskName = TextProcessor.truncateText(this.task.name, 35);
    }
    this.reasonReschedule = '';
  }

  public cancelDueDate(): void
  {
    this.messengerService.sendMessage(new MessageSubject('taskDueDateCancelled'));
    this.dialogOpened = false;
    this.closing.emit();
  }

  public saveDueDate(): void
  {
    this.taskService.updateTaskDueDate(this.task.id, this.dueDate, this.reasonReschedule).subscribe({
      next: () =>
      {
        this.messageHandlerService.displaySuccess('TASK-DUE-TASK-UPDATED-SUCCESSFULLY');
        this.messengerService.sendMessage(new MessageSubject('taskDueDateChanged'));
        this.task.dueDate = new Date(this.dueDate);
        this.dialogOpened = false;
        this.save.emit(this.task);
      }
    });
  }
}
